module.exports = __webpack_public_path__ + "static/media/featureIconThree.618858da.webp";